import { Component, Input, OnInit, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { EoDropdownComponent } from '../eo-dropdown/eo-dropdown.component';
import { IHttpData, STATUS } from '../../common/use-loading.model';
import { EoUserDropdownService } from './eo-user-dropdown.service';
import { User } from './user.model';

@Component({
  selector: 'eo-user-dropdown',
  templateUrl: './eo-user-dropdown.component.html',
  styleUrl: './eo-user-dropdown.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EoUserDropdownComponent),
      multi: true,
    }
  ],
})
export class EoUserDropdownComponent
extends EoDropdownComponent<User>
implements OnInit, IHttpData<User[]>{
  @Input() override optionLabel = 'UserName';
  @Input() url: string = 'v1/users';

  override httpData$ = this.userService.users$;
  override httpStatus$ = this.userService.status$;
  override httpError$ = this.userService.error$;

  override fetchData(): void {
    this.userService.getUsers(this.url).subscribe();
  }

  constructor(private userService: EoUserDropdownService) {
    super();
  }

  override ngOnInit(): void {
    this.fetchData();
    this.subscriptions = [...this.subscriptions, this.onHttpStatusChange()];
  }

  onHttpStatusChange() {
    return this.httpStatus$.subscribe((status) => {
      switch (status) {
        case STATUS.loading:
          this.loading = true;
          break;
        default:
          this.loading = false;
      }
    });
  }
}
